export default __webpack_public_path__ + "static/media/yogatimeTwitter-600x314.f47b43ba.jpg";